import { useEffect } from "react";
import { FixedSiteNav } from "./marketingNav/SiteNav";

interface IframePageProps {
  src: string;
  title: string;
}

const IframePage = ({ src, title }: IframePageProps) => {
  useEffect(() => {
    const prev = document.title;
    document.title = title;
    return () => {
      document.title = prev;
    };
  }, [title]);

  return (
    <>
      <FixedSiteNav />
      <iframe
        src={src}
        title={title}
        style={{
          position: "fixed",
          top: "0px",
          border: "0px",
          left: "0px",
          height: "100%",
          width: "100%",
        }}
      >
        Your browser doesn't support iframes
      </iframe>
    </>
  );
};

export default IframePage;
